var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcFileDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7656 2C10.7656 1.58579 11.1014 1.25 11.5156 1.25H18C19.5188 1.25 20.75 2.48122 20.75 4V15.0145C20.75 15.2137 20.6708 15.4047 20.5298 15.5454L13.5284 22.5324C13.3878 22.6727 13.1972 22.7515 12.9986 22.7515H6C4.48122 22.7515 3.25 21.5203 3.25 20.0015V12C3.25 11.5858 3.58579 11.25 4 11.25C4.41421 11.25 4.75 11.5858 4.75 12V20.0015C4.75 20.6919 5.30964 21.2515 6 21.2515H12.6884L19.25 14.7034V4C19.25 3.30964 18.6904 2.75 18 2.75H11.5156C11.1014 2.75 10.7656 2.41421 10.7656 2Z",
    fill: "#76B72A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 1.25C7.41421 1.25 7.75 1.58579 7.75 2V8.18934L9.46967 6.46967C9.76256 6.17678 10.2374 6.17678 10.5303 6.46967C10.8232 6.76256 10.8232 7.23744 10.5303 7.53033L7.53033 10.5303C7.23744 10.8232 6.76256 10.8232 6.46967 10.5303L3.46967 7.53033C3.17678 7.23744 3.17678 6.76256 3.46967 6.46967C3.76256 6.17678 4.23744 6.17678 4.53033 6.46967L6.25 8.18934V2C6.25 1.58579 6.58579 1.25 7 1.25Z",
    fill: "#76B72A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.25 17C12.25 15.4812 13.4812 14.25 15 14.25H20V15.75H15C14.3096 15.75 13.75 16.3096 13.75 17V22H12.25V17Z",
    fill: "#76B72A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFileDownload);
export default __webpack_public_path__ + "static/media/ic-file-download.011534d00bad9b395fbe4c17079a5324.svg";
export { ForwardRef as ReactComponent };